<template>
    <ArticleComponent
        :viewer="true"
        :model="model"
        :draggable="draggable"
        :inEdit="false"
        @dragstart.native="ondragstart"/>
</template>

<script>
    import ArticleComponent from '../ArticleComponent'
    export default {
        name: 'ArticleViewer',
        components: {ArticleComponent},
        props: ['model', 'draggable'],
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.model))
            },
        },
    }
</script>

<style scoped>
    img {
        max-height: 200px;
        /*width: 100%;*/
        object-fit: initial;
    }
</style>